(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lioren-header"]) return;
  try {
    
  if(!customElements.get('lioren-header'))customElements.define('lioren-header',class extends HTMLElement{
    connectedCallback(){this.resizeObserver?.disconnect();this.resizeObserver=new ResizeObserver(()=>{document.body.style.setProperty("--header-height",this.offsetHeight+"px");document.body.style.setProperty("--header-group-height",this.offsetHeight+"px")});this.resizeObserver.observe(this);this.controller?.abort();this.controller=new AbortController();const options={signal:this.controller.signal};this.dialog=this.querySelector('dialog');this.querySelector('[data-menu-open]')?.addEventListener('click',()=>this.dialog.showModal(),options);this.querySelector('[data-menu-close]')?.addEventListener('click',()=>this.dialog.close(),options);this.dialog?.addEventListener('click',e=>{if(e.target===this.dialog||e.target.closest('a'))this.dialog.close()},options);this.querySelectorAll('.li-header__dropdown').forEach(d=>d.addEventListener('toggle',()=>{if(d.open)this.querySelectorAll('.li-header__dropdown').forEach(other=>{if(other!==d)other.open=false})},options));document.addEventListener('click',e=>{if(!this.contains(e.target))this.querySelectorAll('.li-header__dropdown').forEach(d=>d.open=false)},options);this.addEventListener('keydown',e=>{if(e.key==='Escape')this.querySelectorAll('.li-header__dropdown').forEach(d=>d.open=false)},options)}
    disconnectedCallback(){this.resizeObserver?.disconnect();this.controller?.abort()}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
